import React from 'react';
import { ClickToChat } from '@americanexpress/shared-scripts';
import { BUSINESS_CHECKING_ACCOUNT } from 'axp-product-ducks';
import { BUSINESS_SAVINGS_ACCOUNT, LINE_OF_BUSINESS } from '../constants';
import { useCustomerProducts } from '../hooks/useReadCustomerProducts';

const SupportChatScript = () => {
  const {
    customerProducts,
    isErrorOnCustomerProducts,
    isLoadingCustomerProducts,
  } = useCustomerProducts();

  if (isErrorOnCustomerProducts || isLoadingCustomerProducts) {
    return null;
  }

  const lineOfBusiness = [];
  if (customerProducts?.length > 0) {
    if (customerProducts.some((p) => p.type === BUSINESS_CHECKING_ACCOUNT)) {
      lineOfBusiness.push(LINE_OF_BUSINESS.BUSINESS_CHECKING);
    }
    if (customerProducts.some((p) => p.type === BUSINESS_SAVINGS_ACCOUNT)) {
      lineOfBusiness.push(LINE_OF_BUSINESS.BUSINESS_SAVINGS);
    }
  }
  if (lineOfBusiness.length === 0) {
    return null;
  }

  return (
    <ClickToChat
      version="^1.0.0"
      market="US"
      locale="en-US"
      lineOfBusiness={lineOfBusiness}
    />
  );
};

export default SupportChatScript;
